<template>
  <div
    v-click-outside="onClickOutside"
    v-esc="escape"
    class="fixed-sidebar right"
    :class="{open: openMenu}"
  >
    <div
      id="sidebar-right"
      class="fixed-sidebar-right sidebar--small"
    >
      <div
        ref="scroll"
        data-mcs-theme="dark"
        class="mCustomScrollbar"
      >
        <ul
          v-if="ppa=='per'"
          class="chat-users"
        >
          <li
            v-if="subApp && subApp === 'fin'"
            class="inline-items"
          >
            <div class="author-thumb">
              <router-link :to="getLink('01')">
                <span class="month-sidebar">JAN</span>
              </router-link>
            </div>
          </li>
          <li
            v-if="subApp && subApp === 'fin'"
            class="inline-items"
          >
            <div class="author-thumb">
              <router-link :to="getLink('02')">
                <span class="month-sidebar">FEB</span>
              </router-link>
            </div>
          </li>
          <li
            v-if="subApp && subApp === 'fin'"
            class="inline-items"
          >
            <div class="author-thumb">
              <router-link :to="getLink('03')">
                <span class="month-sidebar">MAR</span>
              </router-link>
            </div>
          </li>
          <li
            v-if="subApp && subApp === 'fin'"
            class="inline-items"
          >
            <div class="author-thumb">
              <router-link :to="getLink('04')">
                <span class="month-sidebar">APR</span>
              </router-link>
            </div>
          </li>
          <li
            v-if="subApp && subApp === 'fin'"
            class="inline-items"
          >
            <div class="author-thumb">
              <router-link :to="getLink('05')">
                <span class="month-sidebar">MAY</span>
              </router-link>
            </div>
          </li>
          <li
            v-if="subApp && subApp === 'fin'"
            class="inline-items"
          >
            <div class="author-thumb">
              <router-link :to="getLink('06')">
                <span class="month-sidebar">JUN</span>
              </router-link>
            </div>
          </li>
          <li
            v-if="subApp && subApp === 'fin'"
            class="inline-items"
          >
            <div class="author-thumb">
              <router-link :to="getLink('07')">
                <span class="month-sidebar">JUL</span>
              </router-link>
            </div>
          </li>

          <li
            v-if="subApp && subApp === 'fin'"
            class="inline-items"
          >
            <div class="author-thumb">
              <router-link :to="getLink('08')">
                <span class="month-sidebar">AUG</span>
              </router-link>
            </div>
          </li>

          <li
            v-if="subApp && subApp === 'fin'"
            class="inline-items"
          >
            <div class="author-thumb">
              <router-link :to="getLink('09')">
                <span class="month-sidebar">SEP</span>
              </router-link>
            </div>
          </li>

          <li
            v-if="subApp && subApp === 'fin'"
            class="inline-items"
          >
            <div class="author-thumb">
              <router-link :to="getLink('10')">
                <span class="month-sidebar">OCT</span>
              </router-link>
            </div>
          </li>

          <li
            v-if="subApp && subApp === 'fin'"
            class="inline-items"
          >
            <div class="author-thumb">
              <router-link :to="getLink('11')">
                <span class="month-sidebar">NOV</span>
              </router-link>
            </div>
          </li>

          <li
            v-if="subApp && subApp === 'fin'"
            class="inline-items"
          >
            <div class="author-thumb">
              <router-link :to="getLink('12')">
                <span class="month-sidebar">DEC</span>
              </router-link>
            </div>
          </li>
          <li
            v-if="subApp && subApp === 'all'"
            class="inline-items"
          >
            <div class="author-thumb">
              <router-link to="/all/reviews">
                <span class="month-sidebar">REV</span>
              </router-link>
            </div>
          </li>
        </ul>
      </div>
      <div class="search-friend inline-items">
        <a
          href="#"
          class="js-sidebar-open"
          :class="{ active : openMenu }"
          @click="openMenu = !openMenu"
        >
          <app-icon
            name="olympus-menu-icon"
            color="gray"
            size="tiny"
          />
        </a>
      </div>
      <router-link
        v-if="ppa==='per' && subApp && subApp ==='all'"
        to="/all/settings"
        class="olympus-chat inline-items"
      >
        <app-icon
          name="olymp-manage-widgets-icon"
          tooltip="Settings"
          color="white"
          size="medium"
        />
      </router-link>
    </div>
    <div
      id="sidebar-right-1"
      class="fixed-sidebar-right sidebar--large"
    >
      <div
        ref="scroll1"
        data-mcs-theme="dark"
        class="mCustomScrollbar"
      >
        <ul
          v-if="ppa=='per'"
          class="chat-users"
        >
          <li
            v-if="subApp && subApp === 'fin'"
            class="inline-items"
          >
            <div class="author-thumb" />
            <div class="author-status">
              <router-link
                :to="getLink('01')"
                class="h4 author-name"
              >
                JANUARY
              </router-link>
            </div>
          </li>
          <li
            v-if="subApp && subApp === 'fin'"
            class="inline-items"
          >
            <div class="author-thumb" />
            <div class="author-status">
              <router-link
                :to="getLink('02')"
                class="h4 author-name"
              >
                FEBRUARY
              </router-link>
            </div>
          </li>
          <li
            v-if="subApp && subApp === 'fin'"
            class="inline-items"
          >
            <div class="author-thumb" />
            <div class="author-status">
              <router-link
                :to="getLink('03')"
                class="h4 author-name"
              >
                MARCH
              </router-link>
            </div>
          </li>
          <li
            v-if="subApp && subApp === 'fin'"
            class="inline-items"
          >
            <div class="author-thumb" />
            <div class="author-status">
              <router-link
                :to="getLink('04')"
                class="h4 author-name"
              >
                APRIL
              </router-link>
            </div>
          </li>
          <li
            v-if="subApp && subApp === 'fin'"
            class="inline-items"
          >
            <div class="author-thumb" />
            <div class="author-status">
              <router-link
                :to="getLink('05')"
                class="h4 author-name"
              >
                MAY
              </router-link>
            </div>
          </li>
          <li
            v-if="subApp && subApp === 'fin'"
            class="inline-items"
          >
            <div class="author-thumb" />
            <div class="author-status">
              <router-link
                :to="getLink('06')"
                class="h4 author-name"
              >
                JUNE
              </router-link>
            </div>
          </li>
          <li
            v-if="subApp && subApp === 'fin'"
            class="inline-items"
          >
            <div class="author-thumb" />
            <div class="author-status">
              <router-link
                :to="getLink('07')"
                class="h4 author-name"
              >
                JULY
              </router-link>
            </div>
          </li>
          <li
            v-if="subApp && subApp === 'fin'"
            class="inline-items"
          >
            <div class="author-thumb" />
            <div class="author-status">
              <router-link
                :to="getLink('08')"
                class="h4 author-name"
              >
                AUGUST
              </router-link>
            </div>
          </li>
          <li
            v-if="subApp && subApp === 'fin'"
            class="inline-items"
          >
            <div class="author-thumb" />
            <div class="author-status">
              <router-link
                :to="getLink('09')"
                class="h4 author-name"
              >
                SEPTEMBER
              </router-link>
            </div>
          </li>
          <li
            v-if="subApp && subApp === 'fin'"
            class="inline-items"
          >
            <div class="author-thumb" />
            <div class="author-status">
              <router-link
                :to="getLink('10')"
                class="h4 author-name"
              >
                OCTOBER
              </router-link>
            </div>
          </li>
          <li
            v-if="subApp && subApp === 'fin'"
            class="inline-items"
          >
            <div class="author-thumb" />
            <div class="author-status">
              <router-link
                :to="getLink('11')"
                class="h4 author-name"
              >
                NOVEMBER
              </router-link>
            </div>
          </li>
          <li
            v-if="subApp && subApp === 'fin'"
            class="inline-items"
          >
            <div class="author-thumb" />
            <div class="author-status">
              <router-link
                :to="getLink('12')"
                class="h4 author-name"
              >
                DECEMBER
              </router-link>
            </div>
          </li>
          <li
            v-if="subApp && subApp === 'all'"
            class="inline-items"
          >
            <div class="author-thumb" />
            <div class="author-status">
              <router-link
                to="/all/reviews"
                class="h4 author-name"
              >
                REVIEWS
              </router-link>
            </div>
          </li>
          <!--<li class="inline-items">
            <select
              v-model="selectedYear"
              class="form-group has-bootstrap-select "
              @change="changeYear"
            >
              <option
                v-for="option in globalYears"
                :key="option"
                :value="option"
                :selected="option == selectedYear"
              >
                {{ option }}
              </option>
            </select>
          </li>-->
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { format } from 'date-fns'
// eslint-disable-next-line
  import Ps from 'perfect-scrollbar';
import VueEsc from 'vue-esc'
import vClickOutside from 'v-click-outside'
Vue.use(VueEsc);
Vue.use(vClickOutside);
// eslint-disable-next-line
import '../../../css/perfect-scrollbar.css'
// import svg1 from '../../../../static/sprites/icons.svg#olymp-menu-icon'
import AppIcon from './AppIcon'

export default {
  name: 'RightSidebar',
  components: { AppIcon },
  props: {
    options: {
      type: Object,
      default () {
        return {
          suppressScrollX: true
        }
      }
    },
    ppa: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      subApp: '',
      openMenu: false,
      selectedYear: Vue.prototype.$currentYear || 0
    }
  },
  computed: {},
  created () {
    if (this.selectedYear === 0) {
      this.selectedYear = format(new Date(),'yyyy')
    }
    Vue.prototype.$currentYear = this.selectedYear
  },
  mounted () {
    let subApp = this.$route.path.substr(1, 3);
    this.subApp = subApp;
    // eslint-disable-next-line
      new Ps(this.$refs.scroll, this.options);
    // eslint-disable-next-line
      new Ps(this.$refs.scroll1, this.options);
  },
  methods: {
    escape () {
      this.openMenu = false
    },
    onClickOutside () {
      this.openMenu = false
    },
    update () {
      Ps.update(this.$refs.scroll)
      Ps.update(this.$refs.scroll1)
    },
    changeYear () {
      Vue.prototype.$currentYear = this.selectedYear
      // console.log(Vue.prototype.$currentYear);
    },
    getLink (month) {
      return `/fin/month/${month}/${Vue.prototype.$currentYear}`
    }
  }
}
</script>
